// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.presize-root .article-box-quantity {
  text-decoration: underline;
  font-weight: 400;
  cursor: pointer;
}
.presize-root .article-box-deviation {
  font-weight: 300;
  font-size: 12px;
}
.presize-root .article-box-deviation-gte-50-warning {
  color: #BE3013;
}
/*# sourceMappingURL=ArticleQuantity.css.map */`, "",{"version":3,"sources":["webpack://./ArticleQuantity.less","webpack://./src/components/SizingGroup/ArticleList/ArticleQuantity/ArticleQuantity.less"],"names":[],"mappings":"AAAA;EAEE,0BAAA;EACA,gBAAA;EACA,eAAA;ACAF;ADJA;EAOE,gBAAA;EACA,eAAA;ACAF;ADRA;EAWE,cAAA;ACAF;AACA,8CAA8C","sourcesContent":[".presize-root { \n .article-box-quantity {\n  text-decoration: underline;\n  font-weight: 400;\n  cursor: pointer;\n}\n.article-box-deviation {\n  font-weight: 300;\n  font-size: 12px;\n}\n.article-box-deviation-gte-50-warning {\n  color: #BE3013;\n}\n \n}",".presize-root .article-box-quantity {\n  text-decoration: underline;\n  font-weight: 400;\n  cursor: pointer;\n}\n.presize-root .article-box-deviation {\n  font-weight: 300;\n  font-size: 12px;\n}\n.presize-root .article-box-deviation-gte-50-warning {\n  color: #BE3013;\n}\n/*# sourceMappingURL=ArticleQuantity.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
